module.exports = __webpack_public_path__ + "static/media/clean-label.dddf0b9a.svg";